/** state **/
import axios from 'axios';
import {KRBS_TONS, APP_TONS} from '../../config/constanst.config';
import {AlertService} from '../../service/alert.service';
import SecureLs from 'secure-ls';
import CryptoJs from 'crypto-js';

const state = {
  cmsUser : {},
  cmsUsers: [],
  formCmsUserData : {
    searchVal: null,
    count: 10,
    page: 1,
  },
};

/** mutations **/
const mutations = {
  set_cms_user(state,payload){
    state.cmsUser = payload
  },

  // table data
  set_cms_users(state,payload){
    state.cmsUsers = payload
  },

  reset_cms_user(state,payload){
    state.cmsUser = {}
  },

  reset_cms_users(state,payload){
    state.cmsUsers = payload
  },

  reset_form_cms_user_data(state){
    state.formCmsUserData = {
      searchVal: null,
      count: 10,
      page: 1,
    }
  },

};

/** actions **/
const actions = {
  async set_cms_user_paginated({commit},payload) {
    commit('set_is_loading',true)
    return await axios.post(KRBS_TONS.STAFF_GET_CMS_USER_PAGINATED,payload).then((r) => {
      commit('set_is_loading',false)
      commit('set_cms_user_pagination',r.data)
      commit('set_cms_users',r.data.data)
      return true;
    }).catch((error) =>{
      // console.log(error)
      AlertService.responseAlertMessage(error,'Get cms user paginated')
      return false;
    });
  },

  reset_cms_user({commit},payload){
    commit('reset_cms_user')
  },

  reset_cms_users({commit}, payload) {
    commit('reset_cms_users')
  },

  reset_form_cms_user_data({commit}) {
    commit('reset_form_cms_user_data')
  }
};

/** getters **/
const getters = {
  cmsUser : state => state.cmsUser,
  cmsUsers : state => state.cmsUsers,
  formCmsUserData : state => state.formCmsUserData,
};

/** export **/
export default {state, actions, mutations, getters};
